// Polyfill IE11; see https://github.com/facebook/create-react-app/tree/master/packages/react-app-polyfill
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import svg4everybody from 'svg4everybody';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import configureStore from './store/';

import '@salesforce-ux/design-system/assets/styles/salesforce-lightning-design-system.css';

import Intl from './i18n/containers/Intl';
import * as Frequency from './frequency/containers';
import * as Common from './common/containers';

import { IconSettings, Settings } from '@salesforce/design-system-react';
import actionSprite from '@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg';
import customSprite from '@salesforce-ux/design-system/assets/icons/custom-sprite/svg/symbols.svg';
import utilitySprite from '@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg';
import standardSprite from '@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg';
import doctypeSprite from '@salesforce-ux/design-system/assets/icons/doctype-sprite/svg/symbols.svg';

// SVG Polyfill for IE/Edge
svg4everybody();

const store = configureStore();
const router = (
  <Provider store={store} appElement={document.getElementById('root')}>
    <Intl>
      <BrowserRouter>
        <IconSettings
          standardSprite={standardSprite}
          utilitySprite={utilitySprite}
          actionSprite={actionSprite}
          doctypeSprite={doctypeSprite}
          customSprite={customSprite}
        >
          <Route exact path="/" component={Frequency.Dashboard} />
          <Route exact path="/activate" component={Frequency.Activate} />
          <Route path="/error" component={Common.ErrorPage} />
        </IconSettings>
      </BrowserRouter>
    </Intl>
  </Provider>
);

// Disable screenreaders for entire App when a Modal is open
Settings.setAppElement(document.getElementById('root'));

ReactDOM.render(router, document.getElementById('root'));
